export default "__VITE_ASSET__BpfIN$ee__"